import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';
import { ApiUrl, Headers } from '../services/ApiUrl';

const ContactFormModal = ({ show, onHide, mailDestino }) => {
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        dni: '',
        telefono: '',
        email: '',
        mensaje: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const formDataToSend = new FormData();
        formDataToSend.append('table', 'sendcontactmail');
        formDataToSend.append('nombre', formData.nombre);
        formDataToSend.append('apellido', formData.apellido);
        formDataToSend.append('dni', formData.dni);
        formDataToSend.append('telefono', formData.telefono);
        formDataToSend.append('email', formData.email);
        formDataToSend.append('mensaje', formData.mensaje);
        formDataToSend.append('mailDestino', mailDestino);

        try {
            const response = await axios.post(ApiUrl + 'sendcontactmail', formDataToSend, { headers: Headers });

            if (response.data.error) {
                throw new Error(response.data.respuesta || 'Error al enviar el mensaje');
            }

            setSuccess(true);
            setTimeout(() => {
                onHide();
                setSuccess(false);
                setFormData({
                    nombre: '',
                    apellido: '',
                    dni: '',
                    telefono: '',
                    email: '',
                    mensaje: '',
                });
            }, 2000);

        } catch (error) {
            setError(error.message || 'Error al enviar el mensaje. Por favor, intente nuevamente.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Contacto</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center mb-4">
                    <h5 className="text-primary mb-2">¿Necesitás ayuda para votar?</h5>
                    <p className="text-muted" style={{ fontSize: '0.95rem' }}>
                        Si tenés algún inconveniente con tu voto, por favor completá el formulario y te ayudaremos a resolverlo a la brevedad.
                    </p>
                </div>

                {success && (
                    <Alert variant="success">
                        Mensaje enviado exitosamente
                    </Alert>
                )}
                {error && (
                    <Alert variant="danger">
                        {error}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            type="text"
                            name="nombre"
                            value={formData.nombre}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Apellido</Form.Label>
                        <Form.Control
                            type="text"
                            name="apellido"
                            value={formData.apellido}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>DNI</Form.Label>
                        <Form.Control
                            type="text"
                            name="dni"
                            value={formData.dni}
                            onChange={handleChange}
                            required
                            pattern="[0-9]*"
                            maxLength="8"
                            placeholder="Sin puntos ni espacios"
                        />
                        <Form.Text className="text-muted">
                            Ingresá tu DNI sin puntos ni espacios
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                            type="tel"
                            name="telefono"
                            value={formData.telefono}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Mensaje</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="mensaje"
                            value={formData.mensaje}
                            onChange={handleChange}
                            required
                        />
                    </Form.Group>
                    <div className="d-grid">
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'Enviando...' : 'Enviar mensaje'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ContactFormModal;